// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"8fc484d1","103":"8fc484d1","242":"8fc484d1","321":"9b032fd6","375":"ebab2c6c","895":"9b032fd6"}[chunkId] + ".chunk.css";
};